import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./Table.css";
// import FullDetail from "../../admin/FullDetail";

// import { IndeterminateCheckBoxOutlined } from "@mui/icons-material";
// import { useParams } from "react-router-dom";


// import { Box } from "@mui/material";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { tokens } from "../../../theme";
// import Header from "./Header";
// import { useTheme } from "@mui/material";




export default function BasicTable({ item }) {
    // const handleClick = (id) => {
    //     console.log("IDDDD", id)

    //     // navigate(`/admin/fulldetail/${id}`)
    // }
    // const theme = useTheme();
    // const colors = tokens(theme.palette.mode);

    // const columns = [
    //     { field: "_id", headerName: "ID", flex: 0.5 },
    //     {
    //         field: "firstName" + "lastName",
    //         headerName: "Name",
    //         flex: 1,
    //         cellClassName: "name-column--cell",
    //     },
    //     {
    //         field: "email",
    //         headerName: "Email",
    //         type: "number",
    //         headerAlign: "left",
    //         align: "left",
    //     },
    //     {
    //         field: "phoneNumber",
    //         headerName: "Phone Number",
    //         flex: 1,
    //     },
    // {
    //     field: "email",
    //     headerName: "Email",
    //     flex: 1,
    // },
    // {
    //     field: "amount",
    //     headerName: "Investment",
    //     flex: 1,
    // },
    // {
    //     field: "city",
    //     headerName: "City",
    //     flex: 1,
    // },
    // {
    //     field: "zipCode",
    //     headerName: "Zip Code",
    //     flex: 1,
    // },
    // ];
    // const { id } = useParams
    // console.log(id)
    return (
        <div className="Table">
            <h3 className="text-xl mb-2">Recent People's</h3>
            <TableContainer
                component={Paper}
                style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            >
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell align="left">Name</TableCell>
                            <TableCell align="left">Email</TableCell>
                            <TableCell align="left">Phone Number</TableCell>
                            <TableCell align="left">Investment</TableCell>
                            <TableCell align="left">Details</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ color: "white" }}>
                        {item.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    00{index + 1}
                                </TableCell>
                                <TableCell align="left">{row.firstName} {row.lastName}</TableCell>
                                <TableCell align="left">{row.email}</TableCell>
                                <TableCell align="left">{row.phoneNumber}
                                </TableCell>
                                <TableCell align="left">{row.amount}</TableCell>
                                <TableCell align="left" className="Details cursor-pointer">
                                    Full Detail
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
        // <Box m="20px">
        //     <Header
        //         title="CONTACTS"
        //         subtitle="List of Contacts for Future Reference"
        //     />
        //     <Box
        //         m="40px 0 0 0"
        //         height="75vh"
        //         sx={{
        //             "& .MuiDataGrid-root": {
        //                 border: "none",
        //             },
        //             "& .MuiDataGrid-cell": {
        //                 borderBottom: "none",
        //             },
        //             "& .name-column--cell": {
        //                 color: colors.greenAccent[300],
        //             },
        //             "& .MuiDataGrid-columnHeaders": {
        //                 backgroundColor: colors.blueAccent[700],
        //                 borderBottom: "none",
        //             },
        //             "& .MuiDataGrid-virtualScroller": {
        //                 backgroundColor: colors.primary[400],
        //             },
        //             "& .MuiDataGrid-footerContainer": {
        //                 borderTop: "none",
        //                 backgroundColor: colors.blueAccent[700],
        //             },
        //             "& .MuiCheckbox-root": {
        //                 color: `${colors.greenAccent[200]} !important`,
        //             },
        //             "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
        //                 color: `${colors.grey[100]} !important`,
        //             },
        //         }}
        //     >
        //         <DataGrid
        //             rows={item}
        //             columns={columns}
        //             components={{ Toolbar: GridToolbar }}
        //         />
        //     </Box>
        // </Box>
    );
}

